import { useEffect } from 'react';
import { prefersReducedMotion } from '../utils/random';

const scrollToHash = (hash, behavior) => {
  if (hash === '#top' || hash === '#') {
    window.scrollTo({ top: 0, behavior });
    return true;
  }
  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) return false;
  // Sections carry scroll-margin-top, so the sticky header never covers the heading.
  target.scrollIntoView({ behavior, block: 'start' });
  return true;
};

// Smooth-scrolls "#section" links inside rootRef and honours a hash on arrival (e.g. /#call).
const useInPageAnchors = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

    const onClick = (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;

      const hash = link.getAttribute('href');
      if (scrollToHash(hash, behavior)) {
        event.preventDefault();
        const url = hash === '#top' ? window.location.pathname : hash;
        window.history.replaceState(window.history.state, '', url);
      }
    };

    root.addEventListener('click', onClick);

    // On arrival: jump to the hash (e.g. /#call), otherwise start at the top —
    // React Router keeps the previous page's scroll position on navigation.
    let frame = 0;
    if (window.location.hash) {
      frame = requestAnimationFrame(() => scrollToHash(window.location.hash, 'auto'));
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      root.removeEventListener('click', onClick);
      cancelAnimationFrame(frame);
    };
  }, [rootRef]);
};

export default useInPageAnchors;
